<div class="template-canvas-region">
  @if (items$ | async; as items) {
    <table>
      <caption hidden translate>
        {{
          name
        }}
      </caption>
      <thead>
        <tr>
          <th [colSpan]="items[0].length">
            <rotec-text-input-v2
              [(value)]="region.name"
              (valueChange)="regionChange.emit(region)"
              placeholder="{{ name | translate }}"
            >
            </rotec-text-input-v2>
          </th>
        </tr>
      </thead>
      @for (row of items; track row; let rowIdx = $index) {
        <tr>
          @for (
            column of row;
            track column;
            let colIdx = $index;
            let first = $first;
            let last = $last
          ) {
            <td [ngClass]="{ 'first-col': first, 'last-col': last }">
              <rc-template-canvas-item
                [item]="items[rowIdx][colIdx]"
                (itemChange)="onItemChanged($event)"
                [row]="rowIdx"
                [col]="colIdx"
                [allowedFieldCategories]="allowedFieldCategories"
              >
              </rc-template-canvas-item>
            </td>
          }
        </tr>
      }
    </table>
  }

  <div class="canvas-region-buttons">
    <button
      rotec-button-primary-v2
      icon="trash"
      (click)="removeRow()"
      [disabled]="region.rows === 1"
    ></button>
    <button
      rotec-button-active
      icon="plus"
      (click)="addRow()"
      [disabled]="region.rows === 20"
    ></button>
  </div>
</div>
